/**
 * MarkdownLite — minimal markdown renderer used by the InspectionDetail page,
 * ReportEditor, and CustomerPortal.
 *
 * Supports: # / ## headings, **bold**, - / * / 1. lists, paragraphs.
 * Deliberately tiny so we don't ship a 60 KB markdown lib for ~10 features.
 */
const renderInline = (s) => {
  const parts = s.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((p, i) =>
    p.startsWith("**") && p.endsWith("**")
      ? <strong key={i} className="text-slate-900">{p.slice(2, -2)}</strong>
      : <span key={i}>{p}</span>
  );
};

const MarkdownLite = ({ text }) => {
  const lines = (text || "").split("\n");
  const out = [];
  let buffer = [];
  const flush = () => {
    if (buffer.length) {
      out.push(<p key={`p-${out.length}`} className="text-sm text-slate-700 my-2">{renderInline(buffer.join(" "))}</p>);
      buffer = [];
    }
  };
  lines.forEach((raw, i) => {
    const line = raw.trim();
    if (!line) { flush(); return; }
    if (line.startsWith("## ")) { flush(); out.push(<h3 key={`h3-${i}`} className="text-base font-black mt-4 mb-2 text-slate-900">{line.slice(3)}</h3>); }
    else if (line.startsWith("# ")) { flush(); out.push(<h2 key={`h2-${i}`} className="text-lg font-black mt-4 mb-2 text-slate-900">{line.slice(2)}</h2>); }
    else if (line.startsWith("- ") || line.startsWith("* ")) { flush(); out.push(<li key={`li-${i}`} className="text-sm ml-5 list-disc text-slate-700">{renderInline(line.slice(2))}</li>); }
    else if (/^\d+\./.test(line)) { flush(); out.push(<li key={`oli-${i}`} className="text-sm ml-5 list-decimal text-slate-700">{renderInline(line.replace(/^\d+\.\s*/, ""))}</li>); }
    else buffer.push(line);
  });
  flush();
  return <>{out}</>;
};

export default MarkdownLite;
